import "./BillingDetailCard.css";

const BillingDetailCard = ({ title, sections = [], actions = null }) => (
  <div className="billing-detail-card">
    <div className="billing-detail-card__header">
      <h2 className="billing-detail-card__title">{title}</h2>
      {actions ? <div className="billing-detail-card__actions">{actions}</div> : null}
    </div>

    <div className="billing-detail-card__body">
      {sections.map((section) => (
        <section className="billing-detail-card__section" key={section.title}>
          <h3 className="billing-detail-card__section-title">{section.title}</h3>
          <div className="billing-detail-card__grid">
            {section.items.map((item) => (
              <div className="billing-detail-card__item" key={item.label}>
                <span className="billing-detail-card__label">{item.label}</span>
                <div className="billing-detail-card__value">{item.value}</div>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  </div>
);

export default BillingDetailCard;
